module.exports = "//static.hsappstatic.net/pricing-pages-ui/static-1.42137/js/v2/hsoc/solutions/images/DataStudioHero.png"